<template>
  <div class="page-container">
    <div class="page-main">
      <el-card class="page-body" v-loading="isLoading">
        <div slot="header">
          <el-form :inline="true" :model="reqParams" size="mini" label-width="120px" class="search-params-form">
            <el-form-item label="旧密码：">
              <el-input placeholder="请输入旧密码" v-model="reqParams.oldPassword" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item label="新密码：">
              <el-input placeholder="请输入新密码" v-model="reqParams.newPassword" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item label=" ">
              <div class="search-button">
                <el-button type="primary" @click="settingMyPasswordOnClick">设置我的密码</el-button>
              </div>
            </el-form-item>
          </el-form>

          <el-form :inline="true" :model="reqParams" size="mini" label-width="120px" class="search-params-form"
            v-if='userRole == "pm" || userRole == "operator" || userRole == "operator-assistant"'>
            <el-form-item label="他人手机：">
              <el-input placeholder="请输入他人手机" v-model="reqParams.phoneNumber" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item label="新密码：">
              <el-input placeholder="请输入新密码" v-model="reqParams.newPassword" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item label=" ">
              <div class="search-button">
                <el-button type="primary" @click="settingOthersPasswordOnClick">重置他人密码</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div> <!-- end of header -->
      </el-card>
    </div>
  </div>
</template>

<script>
import { putRequest } from 'utils/http-service'
import { URL_USER_PASSWORD } from '../../constants/url'
import { SESSION_KEY_USER } from '../../constants/StorageKeys'
import md5 from 'js-md5'

export default {
  name: 'setting-password',

  data () {
    return {
      reqParams: {
        phoneNumber: '', // 如果有值，则修改该电话对应的用户的密码；否则，修改当前用户的密码
        oldPassword: '',
        newPassword: ''
      },
      isLoading: false
    }
  },

  created () {
    let currUser = window.sessionStorage.getItem(SESSION_KEY_USER) && JSON.parse(sessionStorage.getItem(SESSION_KEY_USER))
    this.userRole = currUser.role || ''
  },

  activated () {
    let that = this
    console.log(that.$route.name + ' activated() route params', that.$route.params)
    if (that.$route.params.reload) {
      window.location.reload()
    }
  },

  methods: {
    settingMyPasswordOnClick () {
      let that = this

      if (!that.reqParams.oldPassword || that.reqParams.oldPassword.length === 0) {
        this.$message({ message: '请填写旧密码', type: 'error', showClose: true, offset: 300 })
        return
      }

      if (!that.reqParams.newPassword || that.reqParams.newPassword.length < 6) {
        this.$message({ message: '请填写新密码，长度不少于6位', type: 'error', showClose: true, offset: 300 })
        return
      }

      let params = {
        password: md5(that.reqParams.oldPassword).toUpperCase(),
        newPassword: md5(that.reqParams.newPassword).toUpperCase()
      }
      console.error(that.$route.name + ' settingMyPasswordOnClick() params', params)

      that.isLoading = true
      putRequest(URL_USER_PASSWORD, params)
        .then(res => {
          that.isLoading = false

          if (!res || res.code !== 0) {
            console.error(that.$route.name + ' settingMyPasswordOnClick() res', res)
            that.$message({ message: res.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
            return
          }
          that.$message({ message: '修改成功，请重新登录!', showClose: true, offset: 300, type: 'success' })

          that.reqParams.phoneNumber = ''
          that.reqParams.oldPassword = ''
          that.reqParams.newPassword = ''
          setTimeout(function () {
            that.$router.replace({ path: '/login' })
          }, 1000)
        })
        .catch(err => {
          that.isLoading = false
          console.error(that.$route.name + ' settingMyPasswordOnClick() err', err)
          that.$message({ message: err.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
        })
    },

    settingOthersPasswordOnClick () {
      let that = this

      if (!that.reqParams.phoneNumber || that.reqParams.phoneNumber.length === 0) {
        this.$message({ message: '请填写他人手机号码', type: 'error', showClose: true, offset: 300 })
        return
      }

      if (!that.reqParams.newPassword || that.reqParams.newPassword.length < 6) {
        this.$message({ message: '请填写新密码，长度不少于6位', type: 'error', showClose: true, offset: 300 })
        return
      }

      let params = {
        phoneNumber: that.reqParams.phoneNumber,
        newPassword: md5(that.reqParams.newPassword).toUpperCase()
      }
      console.error(that.$route.name + ' settingOthersPasswordOnClick() params', params)

      that.isLoading = true
      putRequest(URL_USER_PASSWORD, params)
        .then(res => {
          that.isLoading = false

          if (!res || res.code !== 0) {
            console.error(that.$route.name + ' settingOthersPasswordOnClick() res', res)
            that.$message({ message: res.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
            return
          }
          that.$message({ message: '修改成功!', showClose: true, offset: 300, type: 'success' })

          that.reqParams.phoneNumber = ''
          that.reqParams.oldPassword = ''
          that.reqParams.newPassword = ''
        })
        .catch(err => {
          that.isLoading = false
          console.error(that.$route.name + ' settingOthersPasswordOnClick() err', err)
          that.$message({ message: err.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
        })
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  display: flex;
  flex-direction: column;
  width:100%;
  height:100%;
  padding: 15px 20px;
  .page-main {
    flex: 1;
    width:100%;
    height:100%;
    .page-body {
      display: flex;
      flex-direction: column;
      width:100%;
      height:100%;
      overflow-y: auto;
      /deep/ .el-card__header {
        padding: 14px 20px 4px;
        background-color: #fff;
      }
      /deep/ .el-card__body {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        flex: 1;
        padding-top: 0;
        padding-bottom: 0;
      }
      .search-params-form {
        width: 100%;
        height: 100%;
        .search-button {
          display: inline-block;
          margin-right: 70px;
        }
      }
      .role-card-body {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        flex: 1;
        .title-info {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          height: 60px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/settings/password.vue